import { Info } from 'lucide-react';
import { useTenant } from '@/hooks/use-tenant';
import { useI18nContext } from '@/i18n/i18n-react';
import IntegrationDialog from '@/components/integration-dialog';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Lock card shown when the store integration is not configured: the
 * integration dialog, the "app under construction" message or the
 * unsupported-platform text (SALES-08 AC 5). Used by RequireIntegrationLayout
 * and by the Analytics › Pedidos tab.
 */
export function IntegrationRequiredCard() {
  const tenant = useTenant();
  const { LL } = useI18nContext();

  const integrationDialogStore =
    tenant.ecommercePlatform === 'nuvemshop'
      ? 'nuvemshop'
      : tenant.ecommercePlatform === 'shopify'
        ? 'shopify'
        : null;

  // The merchant can't integrate their store until the app exists, so don't
  // offer the integration flow while it is still being built.
  const canIntegrateNow = !tenant.isAppUnderConstruction;

  const title = canIntegrateNow
    ? LL.yourAppIsNotYetIntegratedWithYourStore()
    : LL.availableWhenYourAppIsReady.title();

  const description = !canIntegrateNow
    ? LL.availableWhenYourAppIsReady.description()
    : integrationDialogStore != null
      ? LL.clickTheButtonToIntegrateWithYourStore()
      : LL.korzaDoesNotIntegrateWithYourStoresPlatform();

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <Card className="w-full max-w-lg">
        <CardHeader className="flex flex-row items-center gap-2">
          <Info className="h-5 w-5 text-primary" />
          <CardTitle className="text-lg">{title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">{description}</p>
          <div className="flex flex-row items-center justify-center pt-6">
            {canIntegrateNow && integrationDialogStore && (
              <IntegrationDialog
                store={integrationDialogStore}
                activateIntegrationUrl={tenant.activateIntegrationUrl}
              />
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
